import { type ClassValue, clsx } from "clsx";

export const groupsDocumentation =
  'https://dock.dh.lufthansa-group.com/docs/default/System/be26df2f-284c-f011-877a-7c1e527224bf/tutorials/onboarding/#step-6-setup-group-information';

export const productCatalogBaseUrl='https://lhg-dh.crm4.dynamics.com/main.aspx?appid=1ac085ab-8208-f011-bae4-000d3a385b47&pagetype=entityrecord&etn=dh_product&id='
const validNameRegex = new RegExp('^[a-zA-Z]+$');
export const isValidName = (
  input: string,
  unavailableNames: string[],
): boolean => {
  const result = validNameRegex.exec(input);
  return (
    (result && result.length === 1 && !unavailableNames.includes(input)) ??
    false
  );
};

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
